import { render } from "./EditRuleSetPage.vue?vue&type=template&id=0023f115&ts=true"
import script from "./EditRuleSetPage.vue?vue&type=script&lang=ts"
export * from "./EditRuleSetPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__